import CardSkeleton from 'src/components/DesignSystem/Card/CardSkeleton';
import { useListPresentationContextData } from '../../context/ListPresentationContext';

export function RenderCardSkeleton({ numberOfSkeletons = 4 }) {
  const data = useListPresentationContextData();
  const { getConfigsAndUtils } = data.utilities;
  const { oneGridCellGeometry } = getConfigsAndUtils().generalValues;

  if (!Number.isFinite(numberOfSkeletons) || numberOfSkeletons < 0) return null;
  return (
    <>
      {Array.from({ length: numberOfSkeletons }).map((_, index) => (
        <CardSkeleton
          customStyles={{
            width: `${oneGridCellGeometry.width}px`,
            height: `${oneGridCellGeometry.height?.toFixed(2)}px`,
          }}
          key={index}
        />
      ))}
    </>
  );
}
